let userConstants = {
  LOGIN_REQUEST: "USER_LOGIN_REQUEST",
  LOGIN_SUCCESS: "USER_LOGIN_SUCCESS",
  LOGIN_FAILURE: "USER_LOGIN_FAILURE",
  LOGOUT: "USER_LOGOUT",
  SET_CAPTCHA: "SET_CAPTCHA"
};

export default userConstants;